import { get, set } from 'local-storage';

interface IPersistedGridState {
  filterModel?: any; // agGrid did not provide an interface for the model
  columnState?: any; // agGrid did not provide an interface for the model
}

const saveState = (gridKey: string, modelKey: keyof IPersistedGridState, value: any) => {
  const state = getState(gridKey) || {};
  state[modelKey] = value;
  set<IPersistedGridState>(gridKey, state);
};

export const getState = (key: string): IPersistedGridState => {
  return get<IPersistedGridState>(key);
};

export const saveFilterState = (key: string, value: any) => {
  saveState(key, 'filterModel', value);
};

export const saveColumnState = (key: string, value: any) => {
  saveState(key, 'columnState', value);
};
